import { useOktaAuth } from "@okta/okta-react";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";
import { useContext } from "react";
import { ApplicationState } from "../../context/ApplicationStateContext";
import { useHistory } from "react-router-dom";
import { AxiosError } from "axios";
import toastMessages from "../helpers/toastMessage";
import { isLogoutInProgress } from "../../session/logoutState";
import { performLogout } from "../../session/performLogout";

function useProfile() {
 const data = useOktaAuth();
 const history = useHistory();
 const authState = data?.authState;
 const {
  state: { syncSuccess },
  dispatch,
 } = useContext(ApplicationState);

 const triggerAutoSignOut = (redirectTo: string = "/unauthorized") => {
  if (isLogoutInProgress()) {
   return;
  }
  void performLogout({
   oktaAuth: data.oktaAuth,
   history,
   dispatch,
   redirectTo,
  });
 };

 return useQuery({
  queryKey: ["profile"],
  queryFn: () =>
   axiosInstance
    .get("/v1/auth/new-flow/me", {
     headers: {
      Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
     },
    })
    .then((res) => {
     const profile = res.data.data;
     const roles = profile?.user?.roles ?? [];
     const isPhysicianOnly = roles.length === 1 && roles.includes("Physician");
     const isPLUPhysician =
      roles.includes("Physician") && roles.includes("PathLab User");

     if (isPhysicianOnly || isPLUPhysician) {
      dispatch({ type: "SET_PHYSICIAN", payload: profile?.user?.id });
      dispatch({ type: "SET_PHYSICIAN_DATA", payload: profile?.user});
     }
     if (syncSuccess) {
      if (
       profile &&
       Object.keys(profile).length > 0 &&
       !!roles === false &&
       syncSuccess
      ) {
       triggerAutoSignOut();
      }

      if (
       profile &&
       Object.keys(profile).length > 0 &&
       profile.status === "Blocked" &&
       syncSuccess
      ) {
       triggerAutoSignOut();
      }

      if (roles.includes("Staff")) {
       triggerAutoSignOut();
      }
     }

     return res.data.data;
    })
    .catch((error: AxiosError<any>) => {
     if (error.response?.status === 401 && !isLogoutInProgress()) {
      toastMessages.error(
       error?.response?.data?.message ?? error.response.statusText
      );
      triggerAutoSignOut();
     }
    }),
  staleTime: Infinity,
  enabled:
   !!authState?.accessToken?.accessToken && !isLogoutInProgress(),
  retry: false,
 });
}

export default useProfile;
